import request from '../../../shared/request'

export function getScheduleRepairDates(job_id) {
  return request(`/job/schedules/${job_id}/repair`)
}

export function updateScheduleRepairDates(payload) {
  return request(`/job/schedules/${payload.scheduleId}/repair`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createScheduleRepairSchedule(jobId) {
  return request(`/job/schedules/${jobId}/repair`, {
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteScheduleRepairSchedule(params) {
  return request(`/job/schedules/${params.scheduleId}/repair?jobId=${params.jobId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function updateScheduleRepairNotes(payload) {
  return request(`/job/schedules/${payload.job_id}/repair/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchScheduleRepairNote(jobId) {
  return request(`/job/schedules/${jobId}/notes`)
}

export function createScheduleRepairNote(payload) {
  return request(`/job/schedules/${payload.jobId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editScheduleRepairNote(payload) {
  return request(`/job/schedules/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteScheduleRepairNote(payload) {
  return request(`/job/schedules/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/schedules/${payload.jobId}/repair/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(jobId) {
  return request(`/job/schedules/${jobId}/repair/attachment/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/schedules/${payload.attachmentId}/repair/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/schedules/${payload.attachmentId}/repair/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/scheduleRepair.js